'use client';

import { VerificationCodeModal } from '../physical/VerificationCodeModal';
import { useVerificationCode } from './useVerificationCode';

interface ConnectedVerificationCodeModalProps {
  verification: ReturnType<typeof useVerificationCode>;
}

export const ConnectedVerificationCodeModal = ({
  verification,
}: ConnectedVerificationCodeModalProps) => (
  <VerificationCodeModal
    isOpen={verification.verificationModalOpen}
    onClose={verification.closeVerificationModal}
    onVerified={verification.handleVerified}
    productId={verification.selectedProductIdForCode ?? 0}
    initialCode={
      verification.selectedProductIdForCode !== null
        ? verification.verifiedProductCodes.get(
            verification.selectedProductIdForCode
          )
        : undefined
    }
  />
);
